import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideEditCustomerLegalEntitiesModal } from './editCustomerLegalEntitiesModal';

export const EDIT_CUSTOMER_LEGAL_ENTITIES_REQUEST = 'EDIT_CUSTOMER_LEGAL_ENTITIES_REQUEST';
export const EDIT_CUSTOMER_LEGAL_ENTITIES_SUCCESS = 'EDIT_CUSTOMER_LEGAL_ENTITIES_SUCCESS';
export const EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR = 'EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR';

function requestEditCustomerLegalEntities() {
  return {
    type: EDIT_CUSTOMER_LEGAL_ENTITIES_REQUEST,
  };
}

function receiveEditCustomerLegalEntities() {
  return {
    type: EDIT_CUSTOMER_LEGAL_ENTITIES_SUCCESS
  };
}

function rejectEditCustomerLegalEntitiesError() {
  return {
    type: EDIT_CUSTOMER_LEGAL_ENTITIES_ERROR
  };
}

export function editCustomerLegalEntities(customerList, newLegalEntityId, refreshAction, refreshParameters, batchId) {
  const customerIdList = customerList.map(item => item.id);

  return (dispatch) => {
    dispatch(requestEditCustomerLegalEntities());

    const promise = () => ApiService
      .editCustomerLegalEntityLinks(customerIdList, newLegalEntityId, batchId)
      .then((response) => {
        dispatch(hideEditCustomerLegalEntitiesModal());
        dispatch(receiveEditCustomerLegalEntities(response.data));
        toastr.success('', 'The new legal entity has been applied');
        return dispatch(refreshAction(...refreshParameters));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectEditCustomerLegalEntitiesError, true));
        }
      });
    return promise();
  };
}

export function editCustomerLegalEntitiesWithCallback(customerList, newLegalEntityId, callback) {
  const customerIdList = customerList.map(item => item.id);

  return (dispatch) => {
    dispatch(requestEditCustomerLegalEntities());

    const promise = () => ApiService
      .editCustomerLegalEntityLinks(customerIdList, newLegalEntityId, null)
      .then((response) => {
        dispatch(hideEditCustomerLegalEntitiesModal());
        dispatch(receiveEditCustomerLegalEntities(response.data));
        toastr.success('', 'The new legal entity has been applied');
        callback();
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectEditCustomerLegalEntitiesError, true));
        }
      });
    return promise();
  };
}
